import * as type from '../types/new-space'

export const requestValidateNewSpace = payload => {
    return{
        type: type.REQUEST_VALIDATE_NEW_SPACE,
        details: payload
    }
}

export const resetValidateNewSpace = () => {
    return{
        type: type.RESET_VALIDATE_NEW_SPACE
    }
}
